module.exports = __webpack_public_path__ + "img/2.e2ebac79.jpeg";